<div [@routerTransition]>
    <sub-header [title]="'AddStocks' | localize" [description]="'AddStocksHeaderInfo' | localize">
        <div role="actions">
            <div class="btn-group" dropdown placement="button right">
                <button id="dropdownButtonExcelOperations" dropdownToggle type="button"
                        class="btn btn-outline btn-outline-success btn-active-light-success dropdown-toggle me-1"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                        aria-controls="dropdownMenuExcelOperations">
                    <i class="far fa-file-excel btn-md-icon"></i>
                    <span class="d-none d-md-inline-block">
                        {{ 'ExcelOperations' | localize }}
                    </span>
                </button>
                <ul id="dropdownMenuExcelOperations" class="dropdown-menu dropdown-menu-right dropdown-excel-operations"
                    role="menu" *dropdownMenu aria-labelledby="dropdownButtonExcelOperations">
                    <li role="menuitem">
                        <a class="dropdown-item text-gray-900" id="ExportAddStocksToExcelButton"
                           (click)="this.showExcelColumnSelectionModal()" href="javascript:;">
                            <i class="fa fa-download me-2 mt-1 text-gray-900" style="font-size: 1rem"></i>
                            {{ 'ExportToExcel' | localize }}
                        </a>
                    </li>

                    <!--  <li *ngIf="'Pages.AddStock.Create' | permission" role="menuitem">
                     <a href="javascript:;" class="no-padding">
                         <span class="fileinput-button">
                             <p-fileUpload mode="basic" customUpload="true" name="ExcelFileUpload" #ExcelFileUpload
                                 maxFileSize="10000000" auto="auto" accept=".csv,.xls,.xlsx"
                                 (uploadHandler)="uploadExcel($event)" (onError)="onUploadExcelError()"
                                 chooseLabel="{{ 'ImportFromExcel' | localize }}"></p-fileUpload>
                         </span>
                     </a>
                 </li> -->
                </ul>
            </div>

            <button id="btn_create_addStockInvoice" *ngIf="'Pages.AddStock.Create' | permission"
                    (click)="createAddStock()" class="btn btn-primary blue">
                <i class="fa fa-plus"></i>
                {{ l('CreateNewAddStock') }}
            </button>
        </div>
    </sub-header>

    <div [class]="containerClass">
        <div class="card card-custom gutter-b">
            <div class="card-body">
                <form class="form" autocomplete="off">
                    <div>
                        <div class="row align-items-center">
                            <div class="col-xl-12">
                                <div class="my-3">
                                    <div class="input-group mb-3">
                                        <input [(ngModel)]="filterText" (ngModelChange)="getAddStock()"
                                               name="filterText" autoFocus type="text" class="form-control"
                                               [placeholder]="l('SearchWithThreeDot')" />
                                        <button class="btn btn-primary" type="submit" (click)="getAddStock()">
                                            <i class="flaticon-search-1"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" [hidden]="!advancedFiltersAreShown">
                            <div class="col-md-12"></div>
                            <div class="col-md-3">
                                <div class="my-3">
                                    <label class="form-label" for="VendorDisplayPropertyFilter">
                                        ({{ l('Vendor') }}) {{ l('DisplayProperty') }}
                                    </label>
                                    <input type="text" class="form-control" id="VendorDisplayPropertyFilter"
                                        name="vendorDisplayPropertyFilter" [(ngModel)]="vendorDisplayPropertyFilter" />
                                </div>
                            </div>
                            <div class="col-md-12 mt-5">
                                <button (click)="resetFilters()" class="btn btn-secondary btn-sm"
                                    id="btn-reset-filters">
                                    Reset
                                </button>
                            </div>
                        </div>
                        <div class="row my-4">
                            <div class="col-sm-12">
                                <span class="clickable-item text-muted" *ngIf="!advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-down"></i>
                                    {{ l('ShowAdvancedFilters') }}
                                </span>

                                <span class="clickable-item text-muted" *ngIf="advancedFiltersAreShown"
                                    (click)="advancedFiltersAreShown = !advancedFiltersAreShown">
                                    <i class="fa fa-angle-up"></i>
                                    {{ l('HideAdvancedFilters') }}
                                </span>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="row align-items-center">
                    <!--<Primeng-Datatable-Start>-->
                    <div class="primeng-datatable-container col-12" [busyIf]="primengTableHelper.isLoading">
                        <p-table #dataTable (onLazyLoad)="getAddStock($event)"
                                 [value]="primengTableHelper.records"
                                 rows="{{ primengTableHelper.defaultRecordsCountPerPage }}" [paginator]="false"
                                 tableStyleClass="table table-bordered table-hover" [lazy]="true" [scrollable]="true"
                                 ScrollWidth="100%" [tableStyle]="{ 'min-width': '50rem' }"
                                 [resizableColumns]="primengTableHelper.resizableColumns">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.AddStock.Edit', 'Pages.AddStock.Delete')
                                        ">
                                        {{ l('Actions') }}
                                    </th>
                                    <th style="width: 150px" pSortableColumn="stockNo">
                                        {{ l('StockNo') }}
                                        <p-sortIcon field="addStockInvoice.stockNo"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="stockDate">
                                        {{ l('StockDate') }}
                                        <p-sortIcon field="addStockInvoice.stockDate"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="vendorFk.displayProperty">
                                        {{ l('Vendor') }}
                                        <p-sortIcon field="vendorDisplayProperty"></p-sortIcon>
                                    </th>

                                    <th style="width: 150px" pSortableColumn="remarks">
                                        {{ l('Remarks') }}
                                        <p-sortIcon field="addStockInvoice.remarks"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="stockQty">
                                        {{ l('Qty') }}
                                        <p-sortIcon field="addStock.stockQty"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="totalCost">
                                        {{ l('TotalCost') }}
                                        <p-sortIcon field="addStock.totalCost"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="totalPrice">
                                        {{ l('TotalPrice') }}
                                        <p-sortIcon field="addStock.totalPrice"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="status">
                                        <b>{{ l('Status') }}</b>
                                        <p-sortIcon field="addStockInvoice.status"></p-sortIcon>
                                    </th>
                                    <th style="width: 150px" pSortableColumn="creationTime">
                                        {{ l('CreationTime') }}
                                        <p-sortIcon field="addStockInvoice.creationTime"></p-sortIcon>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-record="$implicit" let-i="rowIndex">
                                <tr>
                                    <td style="width: 5%" [hidden]="
                                            !isGrantedAny('Pages.AddStock.Edit', 'Pages.AddStock.Delete')
                                        ">
                                        <div class="btn-group dropdown" dropdown container="body">
                                            <button class="dropdown-toggle btn btn-sm btn-primary" dropdownToggle>
                                                <i class="fa fa-cog"></i>
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu" *dropdownMenu>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.AddStock.Edit') && record.addStock.status == status.Added"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/stock/addStocks/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.addStock.id }">
                                                        {{ l('View') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a *ngIf="permission.isGranted('Pages.AddStock.Edit') && record.addStock.status == status.Draft"
                                                       class="dropdown-item"
                                                       [routerLink]="[
                                                            '/app/stock/addStocks/createOrEdit',
                                                        ]"
                                                       [queryParams]="{ id: record.addStock.id }">
                                                        {{ l('Edit') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.AddStock.Draft') && record.addStock.status == status.Added"
                                                       (click)="convertToDraft(record.addStock)">
                                                        {{ l('ConvertToDraft') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.AddStock.AddStock') && record.addStock.status == status.Draft"
                                                       (click)="convertToInvoice(record.addStock)">
                                                        {{ l('ConvertToAddStock') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       *ngIf="permission.isGranted('Pages.AddStock.Delete')"
                                                       (click)="deletAddStock(record.addStock)">
                                                        {{ l('Delete') }}
                                                    </a>
                                                </li>
                                                <li>
                                                    <a class="dropdown-item"
                                                       href="javascript:;"
                                                       (click)="print(record.addStock.id)">
                                                        {{ l('Print') }}
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('StockNo') }}</span>
                                        {{ record.addStock.stockNo }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('StockDate') }}</span>

                                        <span *ngIf="record.addStock.stockDate">
                                            {{ record.addStock.stockDate | luxonFormat: "dd-LLL-yyyy" }}
                                        </span>
                                        <span *ngIf="!record.addStock.stockDate">-</span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{l('{{Property_Name_Here}}')}}</span>
                                        {{ record.vendorDisplayProperty }}
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('Remarks') }}</span>
                                        {{ record.addStock.remarks }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('StockQty') }}</span>
                                        {{ record.addStock.stockQty | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('TotalCost') }}</span>
                                        {{ record.addStock.totalCost | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-end">
                                        <span class="p-column-title">{{ l('TotalPrice') }}</span>
                                        {{ record.addStock.totalPrice | priceFormat }}
                                    </td>
                                    <td style="width: 150px" class="text-center">
                                        <span class="p-column-title">{{ l('Status') }}</span>
                                        <span class="badge" [ngClass]="utilsService.getStatusBadgeClass(record.addStock.status)">
                                            <b>{{ l(status[record.addStock.status]) }}</b>
                                        </span>
                                    </td>
                                    <td style="width: 150px">
                                        <span class="p-column-title">{{ l('CreationTime') }}</span>

                                        <span *ngIf="record.addStock.creationTime">
                                            {{ record.addStock.creationTime | luxonFormat: "dd-LLL-yyyy HH:mm" }}
                                        </span>
                                        <span *ngIf="!record.addStock.creationTime">-</span>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>

                        <div class="primeng-no-data" *ngIf="primengTableHelper.totalRecordsCount == 0">
                            {{ l('NoData') }}
                        </div>

                        <div class="primeng-paging-container">
                            <p-paginator [rows]="primengTableHelper.defaultRecordsCountPerPage" #paginator
                                (onPageChange)="getAddStock($event)"
                                [totalRecords]="primengTableHelper.totalRecordsCount"
                                [rowsPerPageOptions]="primengTableHelper.predefinedRecordsCountPerPage"
                                [showCurrentPageReport]="true" [currentPageReportTemplate]="
                                    'TotalRecordsCount' | localize: primengTableHelper.totalRecordsCount
                                "></p-paginator>
                        </div>
                    </div>
                    <!--<Primeng-Datatable-End>-->
                </div>
            </div>
        </div>
    </div>

    <excel-column-selection-modal (modalSave)="exportToExcel($event)"
        #excelColumnSelectionModal></excel-column-selection-modal>
</div>
